import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthorizationService } from '../auth/guards/authorization.service';

@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {

  constructor(private authorizationService: AuthorizationService) {}

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Skips preload if the route doesn't have 'preload' set to true in its data property
    if (!route.data?.['preload']) {
      return of(null);
    }

    // Skips preload if the user doesn't have the required roles for the route
    const roles: string[] = route.data['roles'];
    if (roles?.length && !this.authorizationService.isAuthorized(roles)) {
      return of(null);
    }
    
    // Preloads the module if the user is authorized and 'preload' is true
    return load();
  }
}
